import * as React from 'react'
import HeadShot, { LiaisonHeadshot } from './HeadShot'
import { cn } from '../../../lib/utils'
import AccoladeCards, { LiaisonAccoladeCards } from './AccoladeCards'
import { useTranslation } from '~/hooks/useTranslation'

export default function CoachCard({
  coach,
  coach_photo,
  transparent_coach_photo,
  accolades,
  liaison,
  liason_image_url,
}) {
  const coachImage = transparent_coach_photo || coach_photo

  if (liaison) return <LiaisonCoachCard coachImage={liason_image_url} />
  return (
    <AssignedCoachCard
      coachImage={coachImage}
      coach={coach}
      accolades={accolades}
    />
  )
}

const AssignedCoachCard = ({ coachImage, coach, accolades }) => {
  const { yearsExperience, numClientsSupported } = accolades

  const satisfactionRating = accolades.satisfactionRating

  return (
    <div
      className={cn(
        'grid grid-cols-3 gap-y-4 rounded-[20px] bg-[#E9F2E2] px-2 pb-0 pt-2 xl:static xl:grid-cols-[340px_repeat(3,_minmax(0,_1fr))] xl:gap-x-6 xl:px-8 xl:pt-8',
      )}
    >
      <div className="relative flex items-end xl:col-span-1 xl:row-span-2">
        <div className="absolute -left-2 xl:left-0">
          <HeadShot
            className="w-[7.5rem] xl:w-[18rem]"
            coachImage={coachImage}
          />
        </div>
      </div>

      <div className="col-span-2 flex flex-col justify-around xl:col-span-3 xl:items-start">
        <div className="block font-roboto text-[30px] font-bold uppercase text-intoo-green-coachcta xl:text-[32px]">
          {coach.first_name + ' ' + coach.last_name}
        </div>
      </div>
      <AccoladeCards
        yearsExperience={yearsExperience}
        numClientsSupported={numClientsSupported}
        satisfactionRating={satisfactionRating}
        className={cn('invisible fixed mb-8 xl:visible xl:static xl:flex')}
      />
    </div>
  )
}

export function LiaisonCoachCard({ coachImage }) {
  const { t } = useTranslation('accolades')

  return (
    <div className={cn('flex items-center rounded-[20px] bg-[#E9F2E2]')}>
      <div className="lg:w-[19rem]">
        <LiaisonHeadshot
          className={'rounded-l-[20px]'}
          coachImage={coachImage}
        />
      </div>

      <div className="flex flex-col gap-4 p-4 lg:flex-1 lg:p-8">
        <div className="block font-roboto text-[30px] font-bold uppercase text-intoo-green-coachcta xl:text-[32px]">
          {t('coach_liaison_team')}
        </div>
        <div className="flex gap-12">
          <LiaisonAccoladeCards
            className={cn(
              'invisible fixed mb-8 flex-1 xl:visible xl:static xl:flex',
            )}
          />
        </div>
      </div>
    </div>
  )
}
